<template>
  <a-modal
    centered
    :title="title"
    v-model="visible"
    width="1000px"
    :maskClosable="false"
    :destroyOnClose="true"
    @ok="onSubmit"
  >
    <food-select
      ref="foodSelect"
      :bodyStyle="{
        height: 'auto',
        maxHeight: 'calc(100vh - 240px)',
        minHeight: '50vh'
      }"
      :isChecked="true"
      :params="{
        IsPack: false
      }"
    />
  </a-modal>
</template>
<script>
// import cloneDeep from "lodash/cloneDeep";
import FoodSelect from "./foodSelect";

export default {
  components: { FoodSelect },
  props: {
    title: {
      type: String,
      default: "选择菜品"
    },
    submit: Function
  },
  data() {
    return {
      visible: true
    };
  },

  created() {},
  methods: {
    onSubmit() {
      const foodSelect = this.$refs.foodSelect;
      const selected = foodSelect.getSelected();
      if (!(selected && selected.length)) {
        this.$message.error("请选择更换的菜品");
        return false;
      }
      this.visible = false;
      this.$emit("submit", selected);
    }
  }
};
</script>

<style lang="less" scoped></style>
